import React from 'react';

export const SponsorBanner = ({ sponsorProfile }) => {
  if (!sponsorProfile) return null;

  const { firstName, lastName, photoUri, corporationName, nmlsId } = sponsorProfile;
  if (!firstName) return null;

  return (
    <div className="sponsor-banner">
      <h2 className="sponsor-banner-text">
        Sign up with {firstName} as your co-sponsor
      </h2>
      <div className="sponsor-banner-details">
        <div className="sponsor-banner-photo-ring">
          {photoUri ? (
            <img
              src={photoUri}
              alt={`${firstName}'s profile`}
              className="sponsor-banner-photo"
            />
          ) : (
            <div className="sponsor-banner-photo-placeholder" aria-label={`${firstName}'s profile`}>
              {firstName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <div className="sponsor-banner-info">
          <span className="sponsor-banner-name">
            {firstName} {lastName}
          </span>
          {corporationName && (
            <span className="sponsor-banner-company">{corporationName}</span>
          )}
          {nmlsId && (
            <span className="sponsor-banner-nmls">NMLS: #{nmlsId}</span>
          )}
        </div>
      </div>
    </div>
  );
};

